import ProductFlavorSummary from './ProductFlavorSummary';
export default ProductFlavorSummary;
